var _rect, _rect2, _polygon, _rect3, _polygon2, _polygon3, _rect4, _polygon4, _rect5, _rect6, _polygon5, _rect7, _rect8, _rect9, _g, _path, _path2, _path3, _rect0, _rect1, _rect10, _rect11, _rect12, _path4, _path5, _path6, _path7, _path8, _polygon6, _polygon7, _rect13, _rect14, _path9, _rect15, _rect16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3n-web/art/house") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "3n-web/art/house",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("g", {
    id: "art/house-copy",
    transform: "translate(5, 21)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(79.0683, 36.726)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8B5E3C",
    x: 2.82557473,
    y: 13.9333639,
    width: 1.37553334,
    height: 5.21836748
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#39B54A",
    points: "6.50512641 17.145251 0 17.145251 3.25160797 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    points: "6.50512641 17.145251 3.67955168 17.145251 3.67955168 19.1517314 3.25160797 19.1517314 3.25160797 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.7707, 0)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A7A9AC",
    x: 31.7442527,
    y: 55.1753617,
    width: 38.7823983,
    height: 1.36676049
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#131D47",
    points: "67.2158186 15.222295 40.138827 0.99659619 23.9247278 9.85016692 23.9247278 55.8492505 67.2559384 55.8492505"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1E2969",
    points: "3.07966631 15.9132683 19.0129275 8.04300583 34.9691142 15.9227597 34.9691142 32.7984552 30.6839457 32.7984552 29.9063873 36.9101263 34.9691142 36.9101263 34.9480991 55.8492505 3.07966631 55.8492505"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#524640",
    x: 36.9922945,
    y: 38.8615566,
    width: 7.55397058,
    height: 14.6186424
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#7F341D",
    transform: "translate(40.7693, 46.1699) rotate(90) translate(-40.7693, -46.1699)",
    points: "33.9734429 42.9087684 47.5651166 42.9087684 47.5651166 49.4310889 33.9734429 49.4310889"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    },
    points: "35.0187862 36.9291091 35.0187862 55.8492505 78.779851 55.8492505 71.3462396 36.9291091"
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 69.0689677,
    y: 36.9044315,
    width: 1.45577278,
    height: 16.5814623
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 46.4681908,
    y: 36.9044315,
    width: 1.45577278,
    height: 16.5890554
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9A5238",
    points: "71.3634337 36.9101263 29.9063873 36.9101263 30.1451952 35.6458729 30.1929568 35.3896053 30.4203019 34.1917916 30.4680634 33.935524 30.6839457 32.7984552 34.9691142 32.7984552 34.9691142 30.1560516 68.7804878 30.1560516 69.1148188 31.0254631 69.2122524 31.2817307 69.6688531 32.4814427 69.7681972 32.7377103 70.2267083 33.935524 70.3241419 34.1917916 70.7807425 35.3896053 70.8800866 35.6458729"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D1D3D4",
    x: 31.7442527,
    y: 53.4934869,
    width: 38.7823983,
    height: 2.35576357
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BCBEC0",
    x: 31.7442527,
    y: 54.5014728,
    width: 38.7823983,
    height: 1.36676049
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 47.9239636,
    y: 51.2459252,
    width: 21.1469146,
    height: 1.36676049
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    x: 47.9239636,
    y: 51.9444917,
    width: 21.1469146,
    height: 1.36676049
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.1452, 31.0255)",
    fill: "#7F341D",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.0670573 1.36676049 4.823919 1.36676049 4.823919 0 38.9696236 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.623002 2.82274007 4.823919 2.82274007 4.823919 1.45597958 39.5236579 1.45597958"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.1789467 4.27682137 0.275106668 4.27682137 0.322868242 2.91006088 40.0815131 2.91006088"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.7348914 5.73090266 0 5.73090266 0.0477615742 4.36414217 40.6355473 4.36414217"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5315545,6.503502 C41.5315545,7.26850821 40.9068331,7.88734699 40.138827,7.88734699 C39.3708209,7.88734699 38.7460995,7.26850821 38.7460995,6.503502 C38.7460995,5.73849578 39.3708209,5.12155528 40.138827,5.12155528 C40.9068331,5.12155528 41.5315545,5.74039406 41.5315545,6.503502 Z",
    id: "Path",
    fill: "#8AD2F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.138827,8.27079924 C39.156849,8.27079924 38.360186,7.47731885 38.360186,6.50160372 C38.360186,5.52588859 39.1587595,4.73430647 40.138827,4.73430647 C41.1188945,4.73430647 41.9193785,5.52778687 41.9193785,6.50160372 C41.9193785,7.47542057 41.1208049,8.27079924 40.138827,8.27079924 Z M40.138827,5.50500753 C39.5847927,5.50500753 39.1339235,5.95300124 39.1339235,6.50160372 C39.1339235,7.05020619 39.5847927,7.50009819 40.138827,7.50009819 C40.6928612,7.50009819 41.1437305,7.05210447 41.1437305,6.50160372 C41.1437305,5.95110297 40.6928612,5.50500753 40.138827,5.50500753 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    points: "20.5642234 8.04300583 4.59275298 16.1277738 1.54938547 16.1277738 19.0415844 7.27420305"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    points: "40.5056359 0.56568698 24.350761 9.36990247 25.9364453 10.170976 41.0692224 1.92485436"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    points: "34.1781825 36.9044315 32.8026492 36.9044315 32.8026492 53.4934869 34.1781825 53.4858938"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8011845,47.6145186 C43.4229128,47.6145186 43.1134178,47.5215029 43.1134178,47.4057079 L43.1134178,46.2648426 C43.1134178,46.1490476 43.4229128,46.0560319 43.8011845,46.0560319 C44.1794562,46.0560319 44.4889512,46.1490476 44.4889512,46.2648426 L44.4889512,47.4057079 C44.4889512,47.5215029 44.1794562,47.6145186 43.8011845,47.6145186 Z",
    id: "Path",
    fill: "#403732"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8AD2F0",
    x: 10.601159,
    y: 18.0032729,
    width: 16.8254474,
    height: 10.8790338
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8AD2F0",
    x: 10.601159,
    y: 38.5350527,
    width: 16.8254474,
    height: 10.8790338
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8AD2F0",
    x: 49.1982424,
    y: 39.170976,
    width: 16.8254474,
    height: 10.8790338
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8AD2F0",
    x: 49.1562122,
    y: 18.0032729,
    width: 16.8254474,
    height: 10.8790338
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8AD2F0",
    x: 37.5329555,
    y: 18.0032729,
    width: 8.34299179,
    height: 10.8790338
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "59.459339 18.0032729 59.1517544 18.7739739 57.4399796 23.0583884 57.1304846 23.8271912 55.4187098 28.113504 55.1111253 28.8823067 54.9487359 28.8823067 52.9981532 28.113504 52.7669872 28.0223866 53.471948 26.2569876 54.247596 24.3188453 54.4443737 23.8271912 54.7519582 23.0583884 56.463733 18.7739739 56.7713176 18.0032729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "61.1577406 18.3848269 60.8902757 19.0587157 59.2912182 23.0583884 58.9836337 23.8271912 57.2718589 28.113504 56.9623639 28.8823067 55.4339935 28.8823067 55.7434885 28.113504 57.4552633 23.8271912 57.7628479 23.0583884 59.4765331 18.7739739 59.7841177 18.0032729 60.1891358 18.0032729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "62.3708845 18.863193 61.6640132 20.6266937 60.8902757 22.564836 60.6915876 23.0583884 60.3859135 23.8271912 58.6722282 28.113504 58.3646437 28.8823067 57.5068458 28.8823067 57.8144304 28.113504 59.5281156 23.8271912 59.8357002 23.0583884 60.8902757 20.4197814 61.6296249 18.5727564 62.141629 18.7739739"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "44.7354009 18.0032729 44.4278163 18.7739739 42.7141311 23.0583884 42.4065465 23.8271912 42.0913201 24.6149768 41.3175826 26.5531191 40.6928612 28.113504 40.3852767 28.8823067 40.3852767 28.8861033 40.3738139 28.8823067 38.4251417 28.113504 38.306693 28.066047 38.0640642 27.9711331 38.306693 27.363684 39.7204356 23.8271912 40.0280201 23.0583884 41.3175826 19.8332133 42.0473795 18.0032729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "45.8759473 18.1057799 45.8759473 19.7838581 45.1022098 21.7238987 44.5672801 23.0583884 44.2596956 23.8271912 42.5460103 28.113504 42.2403362 28.8823067 40.7100554 28.8823067 41.0195504 28.113504 41.3175826 27.3655822 42.0913201 25.4274399 42.7313252 23.8271912 43.0389098 23.0583884 44.7506846 18.7739739 45.0582691 18.0032729 45.6161243 18.0032729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "45.8759473 21.146822 45.8759473 23.2899784 45.1022098 25.2262224 43.9482901 28.113504 43.6387951 28.8823067 42.7829077 28.8823067 43.0904923 28.113504 44.8041775 23.8271912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "17.3909444 38.8406755 17.2056295 39.3057537 15.6906324 43.0947175 14.9168949 45.0328599 13.4725849 48.6452838 13.1650003 49.4159848 11.3748965 49.4159848 10.5992486 49.110362 11.3748965 47.1703214 12.4982487 44.3608693 12.8058333 43.5901682 14.5195186 39.3057537 14.8271031 38.5350527 16.6172069 38.5350527"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "21.383812 38.8406755 21.1984971 39.3057537 19.4848118 43.5901682 19.1772273 44.3608693 17.463542 48.6452838 17.1578679 49.4159848 15.3677641 49.4159848 14.5940266 49.110362 14.7793415 48.6452838 14.9168949 48.3016954 15.6906324 46.3616548 16.4911163 44.3608693 16.7987009 43.5901682 18.5123862 39.3057537 18.8199707 38.5350527 20.6100745 38.5350527"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "24.066102 38.9185049 23.9113545 39.3057537 23.4967841 40.3422138 22.7230466 42.2822544 22.1995797 43.5901682 21.8919952 44.3608693 20.1783099 48.6452838 19.8707253 49.4159848 18.342355 49.4159848 18.65185 48.6452838 20.3636248 44.3608693 20.6712093 43.5901682 22.3829841 39.3057537 22.6905687 38.5350527 23.0974973 38.5350527"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "27.4266064 38.986843 27.4266064 40.3061465 27.0387824 41.2761668 26.6509584 42.2461871 26.1141183 43.5901682 25.8046233 44.3608693 24.0928485 48.6452838 23.785264 49.4159848 22.9293766 49.4159848 23.2369611 48.6452838 23.4967841 47.992276 24.9487359 44.3608693 25.2563204 43.5901682 26.6509584 40.0992341 26.9680953 39.3057537 27.1419474 38.8729463"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "59.5586831 39.4063625 59.3447112 39.941677 57.6310259 44.2260915 57.3234414 44.9967926 55.6116666 49.281207 55.304082 50.0500098 53.7203082 50.0500098 52.7669872 49.6741507 52.9255556 49.281207 53.5120678 47.8100412 54.2877157 45.8700007 54.6373304 44.9967926 54.944915 44.2260915 56.6586003 39.941677 56.9642743 39.1728743 58.9664395 39.1728743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "61.1577406 40.036591 60.9303955 40.6060745 59.484175 44.2260915 59.1765905 44.9967926 57.4629052 49.281207 57.1553206 50.0500098 55.6288607 50.0500098 55.9364453 49.281207 57.6482201 44.9967926 57.9558046 44.2260915 59.6675794 39.941677 59.8395211 39.5164627 60.9189327 39.941677 60.9303955 39.9473719"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "63.4713112 39.1728743 63.1637267 39.941677 61.7060434 43.5882699 60.9303955 45.5283105 59.4325925 49.281207 59.125008 50.0500098 58.2672101 50.0500098 58.5747946 49.281207 60.2865694 44.9967926 60.594154 44.2260915 60.9303955 43.3832559 61.7060434 41.4451136 62.3059288 39.941677 62.6135133 39.1728743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "66.0217793 39.1728743 66.0217793 39.9625581 65.2480418 41.9007004 64.3176463 44.2260915 64.0100618 44.9967926 62.298287 49.281207 61.9907024 50.0500098 61.3220404 50.0500098 61.1577406 49.9854684 61.7060434 48.6168096 63.1522639 44.9967926 63.4617589 44.2260915 65.1735337 39.941677 65.4830287 39.1728743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "66.0217793 41.5058585 66.0217793 43.6509131 65.2480418 45.5890554 63.7731644 49.281207 63.4636694 50.0500098 62.607782 50.0500098 62.9153665 49.281207 64.6271413 44.9967926 64.9347258 44.2260915 65.2480418 43.4458991"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "21.3436923 18.0032729 21.0361078 18.7739739 19.3243329 23.0583884 19.0148379 23.8271912 17.3030631 28.113504 16.9954786 28.8823067 16.3936827 28.8823067 14.5940266 28.1723506 14.6169522 28.113504 14.9168949 27.363684 15.6906324 25.4255417 16.328727 23.8271912 16.638222 23.0583884 18.3499968 18.7739739 18.6575814 18.0032729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "23.372604 18.5366891 22.7230466 20.1616155 21.565306 23.0583884 21.255811 23.8271912 19.5440362 28.113504 19.2364516 28.8823067 17.7080813 28.8823067 18.0137553 28.113504 19.7274406 23.8271912 20.0350252 23.0583884 21.7487104 18.7739739 22.052474 18.0146626"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "25.2735146 18.0032729 24.9659301 18.7739739 23.4967841 22.449041 22.7230466 24.3890816 21.2328854 28.113504 20.9253009 28.8823067 20.0694135 28.8823067 20.376998 28.113504 22.0887728 23.8271912 22.3963574 23.0583884 22.7230466 22.244027 23.4967841 20.3058847 24.1100427 18.7739739 24.4157167 18.0032729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    },
    points: "27.4266064 20.1293448 27.4266064 22.2706029 26.8037955 23.8271912 26.6509584 24.2087452 25.0901102 28.113504 24.7825256 28.8823067 23.9266382 28.8823067 24.2323123 28.113504 25.947908 23.8271912 26.2535821 23.0583884 26.6509584 22.0655888 27.0387824 21.0974668"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6860319,23.0583884 L19.0148379,24.4251489 L19.7191773,24.4251489 L20.3903713,23.0583884 L19.6860319,23.0583884 Z M19.6860319,23.0583884 L19.0148379,24.4251489 L19.7191773,24.4251489 L20.3903713,23.0583884 L19.6860319,23.0583884 Z M19.6860319,23.0583884 L19.0148379,24.4251489 L19.7191773,24.4251489 L20.3903713,23.0583884 L19.6860319,23.0583884 Z M10.601159,18.0032729 L10.601159,28.8823067 L27.4266064,28.8823067 L27.4266064,18.0032729 L10.5992486,18.0032729 L10.601159,18.0032729 Z M23.1108705,18.7739739 L26.6528689,18.7739739 L26.6528689,23.0583884 L23.1108705,23.0583884 L23.1108705,18.7739739 Z M14.9168949,28.113504 L11.3748965,28.113504 L11.3748965,23.8290895 L14.9168949,23.8290895 L14.9168949,28.113504 Z M14.9168949,23.0583884 L11.3748965,23.0583884 L11.3748965,18.7739739 L14.9168949,18.7739739 L14.9168949,23.0583884 Z M22.3352226,28.113504 L15.6925428,28.113504 L15.6925428,23.8290895 L22.3352226,23.8290895 L22.3352226,28.113504 Z M22.3352226,23.0583884 L15.6925428,23.0583884 L15.6925428,18.7739739 L22.3352226,18.7739739 L22.3352226,23.0583884 Z M26.6509584,28.113504 L23.1089601,28.113504 L23.1089601,23.8290895 L26.6509584,23.8290895 L26.6509584,28.113504 Z M19.6860319,23.0583884 L19.0148379,24.4251489 L19.7191773,24.4251489 L20.3903713,23.0583884 L19.6860319,23.0583884 Z M19.6860319,23.0583884 L19.0148379,24.4251489 L19.7191773,24.4251489 L20.3903713,23.0583884 L19.6860319,23.0583884 Z M19.6860319,23.0583884 L19.0148379,24.4251489 L19.7191773,24.4251489 L20.3903713,23.0583884 L19.6860319,23.0583884 Z M19.6860319,23.0583884 L19.0148379,24.4251489 L19.7191773,24.4251489 L20.3903713,23.0583884 L19.6860319,23.0583884 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6906324,43.5901682 L15.6906324,43.0928193 L14.9149844,45.0309616 L14.9149844,48.2997971 L15.6906324,46.3616548 L15.6906324,44.358971 L19.9758008,44.358971 L20.2833853,43.5882699 L15.6906324,43.5882699 L15.6906324,43.5901682 Z M15.6906324,43.5901682 L15.6906324,43.0928193 L14.9149844,45.0309616 L14.9149844,48.2997971 L15.6906324,46.3616548 L15.6906324,44.358971 L19.9758008,44.358971 L20.2833853,43.5882699 L15.6906324,43.5882699 L15.6906324,43.5901682 Z M15.6906324,43.5901682 L15.6906324,43.0928193 L14.9149844,45.0309616 L14.9149844,48.2997971 L15.6906324,46.3616548 L15.6906324,44.358971 L19.9758008,44.358971 L20.2833853,43.5882699 L15.6906324,43.5882699 L15.6906324,43.5901682 Z M10.5992486,38.5350527 L10.5992486,49.4140865 L27.4246959,49.4140865 L27.4246959,38.5350527 L10.5992486,38.5350527 L10.5992486,38.5350527 Z M11.3748965,39.3057537 L14.9168949,39.3057537 L14.9168949,43.5901682 L11.3748965,43.5901682 L11.3748965,39.3057537 Z M14.9168949,48.6452838 L11.3748965,48.6452838 L11.3748965,44.3608693 L14.9168949,44.3608693 L14.9168949,48.6452838 Z M22.3352226,48.6452838 L15.6925428,48.6452838 L15.6925428,44.3608693 L22.3352226,44.3608693 L22.3352226,48.6452838 Z M22.3352226,43.5901682 L15.6925428,43.5901682 L15.6925428,39.3057537 L22.3352226,39.3057537 L22.3352226,43.5901682 Z M26.6509584,48.6452838 L23.1089601,48.6452838 L23.1089601,44.3608693 L26.6509584,44.3608693 L26.6509584,48.6452838 Z M26.6509584,43.5901682 L23.1089601,43.5901682 L23.1089601,39.3057537 L26.6509584,39.3057537 L26.6509584,43.5901682 Z M15.6906324,43.5901682 L15.6906324,43.0928193 L14.9149844,45.0309616 L14.9149844,48.2997971 L15.6906324,46.3616548 L15.6906324,44.358971 L19.9758008,44.358971 L20.2833853,43.5882699 L15.6906324,43.5882699 L15.6906324,43.5901682 Z M15.6906324,43.5901682 L15.6906324,43.0928193 L14.9149844,45.0309616 L14.9149844,48.2997971 L15.6906324,46.3616548 L15.6906324,44.358971 L19.9758008,44.358971 L20.2833853,43.5882699 L15.6906324,43.5882699 L15.6906324,43.5901682 Z M15.6906324,43.5901682 L15.6906324,43.0928193 L14.9149844,45.0309616 L14.9149844,48.2997971 L15.6906324,46.3616548 L15.6906324,44.358971 L19.9758008,44.358971 L20.2833853,43.5882699 L15.6906324,43.5882699 L15.6906324,43.5901682 Z M15.6906324,43.5901682 L15.6906324,43.0928193 L14.9149844,45.0309616 L14.9149844,48.2997971 L15.6906324,46.3616548 L15.6906324,44.358971 L19.9758008,44.358971 L20.2833853,43.5882699 L15.6906324,43.5882699 L15.6906324,43.5901682 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9925074,44.2260915 L57.3234414,45.592852 L58.0299087,45.592852 L58.6989747,44.2260915 L57.9925074,44.2260915 Z M57.9925074,44.2260915 L57.3234414,45.592852 L58.0299087,45.592852 L58.6989747,44.2260915 L57.9925074,44.2260915 Z M57.9925074,44.2260915 L57.3234414,45.592852 L58.0299087,45.592852 L58.6989747,44.2260915 L57.9925074,44.2260915 Z M57.9925074,44.2260915 L57.3234414,45.592852 L58.0299087,45.592852 L58.6989747,44.2260915 L57.9925074,44.2260915 Z M57.9925074,44.2260915 L57.3234414,45.592852 L58.0299087,45.592852 L58.6989747,44.2260915 L57.9925074,44.2260915 Z M49.1963319,39.170976 L49.1963319,50.0500098 L66.0217793,50.0500098 L66.0217793,39.170976 L49.1963319,39.170976 Z M54.2877157,39.941677 L60.9303955,39.941677 L60.9303955,44.2260915 L54.2877157,44.2260915 L54.2877157,39.941677 Z M49.9719799,39.941677 L53.5139782,39.941677 L53.5139782,44.2260915 L49.9719799,44.2260915 L49.9719799,39.941677 Z M49.9719799,44.9967926 L53.5139782,44.9967926 L53.5139782,49.281207 L49.9719799,49.281207 L49.9719799,44.9967926 Z M60.9323059,49.281207 L54.2896262,49.281207 L54.2896262,44.9967926 L60.9323059,44.9967926 L60.9323059,49.281207 Z M65.2480418,49.281207 L61.7060434,49.281207 L61.7060434,44.9967926 L65.2480418,44.9967926 L65.2480418,49.281207 Z M65.2480418,44.2279898 L61.7060434,44.2279898 L61.7060434,39.9435753 L65.2480418,39.9435753 L65.2480418,44.2279898 Z M57.9944179,44.2279898 L57.3253518,45.5947503 L58.0318191,45.5947503 L58.7008852,44.2279898 L57.9944179,44.2279898 Z M57.9944179,44.2279898 L57.3253518,45.5947503 L58.0318191,45.5947503 L58.7008852,44.2279898 L57.9944179,44.2279898 Z M57.9944179,44.2279898 L57.3253518,45.5947503 L58.0318191,45.5947503 L58.7008852,44.2279898 L57.9944179,44.2279898 Z M57.9944179,44.2279898 L57.3253518,45.5947503 L58.0318191,45.5947503 L58.7008852,44.2279898 L57.9944179,44.2279898 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8037064,23.0583884 L57.1304846,24.4251489 L57.8369519,24.4251489 L58.506018,23.0583884 L57.7995507,23.0583884 L57.8037064,23.0583884 Z M57.8037064,23.0583884 L57.1304846,24.4251489 L57.8369519,24.4251489 L58.506018,23.0583884 L57.7995507,23.0583884 L57.8037064,23.0583884 Z M57.8037064,23.0583884 L57.1304846,24.4251489 L57.8369519,24.4251489 L58.506018,23.0583884 L57.7995507,23.0583884 L57.8037064,23.0583884 Z M49.1562122,18.0032729 L49.1562122,28.8823067 L65.9816596,28.8823067 L65.9816596,18.0032729 L49.1562122,18.0032729 Z M49.9318602,18.7739739 L53.4738585,18.7739739 L53.4738585,23.0583884 L49.9318602,23.0583884 L49.9318602,18.7739739 Z M49.9318602,28.113504 L49.9318602,23.8290895 L53.4738585,23.8290895 L53.4738585,28.113504 L49.9318602,28.113504 Z M60.8921862,28.113504 L54.2495065,28.113504 L54.2495065,23.8290895 L60.8921862,23.8290895 L60.8921862,28.113504 Z M60.8921862,23.0583884 L54.2495065,23.0583884 L54.2495065,18.7739739 L60.8921862,18.7739739 L60.8921862,23.0583884 Z M65.2079221,28.113504 L61.6659237,28.113504 L61.6659237,23.8290895 L65.2079221,23.8290895 L65.2079221,28.113504 Z M65.2079221,23.0583884 L61.6659237,23.0583884 L61.6659237,18.7739739 L65.2079221,18.7739739 L65.2079221,23.0583884 Z M57.8037064,23.0583884 L57.1304846,24.4251489 L57.8369519,24.4251489 L58.506018,23.0583884 L57.7995507,23.0583884 L57.8037064,23.0583884 Z M57.8037064,23.0583884 L57.1304846,24.4251489 L57.8369519,24.4251489 L58.506018,23.0583884 L57.7995507,23.0583884 L57.8037064,23.0583884 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.531045,18.0032729 L37.531045,28.8823067 L45.8759473,28.8823067 L45.8759473,18.0032729 L37.531045,18.0032729 L37.531045,18.0032729 Z M38.306693,18.7739739 L41.3175826,18.7739739 L41.3175826,23.0583884 L38.306693,23.0583884 L38.306693,18.7739739 L38.306693,18.7739739 Z M41.3175826,28.113504 L38.306693,28.113504 L38.306693,23.8290895 L41.3175826,23.8290895 L41.3175826,28.113504 Z M45.1022098,23.8290895 L45.1022098,28.113504 L42.0932306,28.113504 L42.0932306,23.8290895 L45.1022098,23.8290895 Z M45.1022098,23.0583884 L42.0932306,23.0583884 L42.0932306,18.7739739 L45.1022098,18.7739739 L45.1022098,23.0583884 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9A5238",
    points: "38.0277654 16.1277738 34.9843979 16.1277738 19.0129275 8.04300583 3.04336751 16.1277738 0 16.1277738 19.0129275 6.503502"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7F341D",
    points: "40.035662 0 23.319111 9.11363488 24.9047953 9.91470839 40.035662 1.66858676 67.4393428 16.1885187 70.5419347 16.1885187"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    points: "34.9691142 16.1277738 34.9691142 32.7984552 44.5596383 32.8003535 38.022034 16.1277738"
  }), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 31.7442527,
    y: 36.9044315,
    width: 1.45577278,
    height: 16.5890554
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    x: 32.8026492,
    y: 36.9044315,
    width: 1.37553334,
    height: 16.5890554
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    x: 70.1292747,
    y: 36.9006349,
    width: 1.37553334,
    height: 16.5890554
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    x: 47.5265873,
    y: 36.9044315,
    width: 1.37553334,
    height: 16.5890554
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 41.3141)"
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8B5E3C",
    x: 5.2518627,
    y: 10.7043922,
    width: 1.37553334,
    height: 3.93513124
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3634337,5.64548013 C11.3634337,8.62008248 9.04795262,11.057472 6.10775011,11.275774 L6.10392919,11.275774 C5.96446539,11.2852654 5.82309113,11.2909603 5.68171687,11.2909603 L5.67789594,11.2909603 C5.53652168,11.2909603 5.39514742,11.2852654 5.25568363,11.275774 L5.2518627,11.275774 C2.31357066,11.0555737 0,8.62008248 0,5.64548013 C0,2.67087779 2.54091575,0.00189827846 5.67789594,0 L5.68171687,0 C8.82060753,0 11.3634337,2.52850691 11.3634337,5.64548013 Z",
    id: "Path",
    fill: "#39B54A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3634337,5.64548013 C11.3634337,8.62008248 9.04795262,11.057472 6.10775011,11.275774 L6.10392919,11.275774 L6.10392919,14.6414217 L5.67789594,14.6414217 L5.67789594,0 L5.68171687,0 C8.82060753,0 11.3634337,2.52850691 11.3634337,5.64548013 L11.3634337,5.64548013 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#39B54A",
    x: 0.46997389,
    y: 55.900504,
    width: 89.5300261,
    height: 1.36676049
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#009245",
    x: 0.46997389,
    y: 56.6332395,
    width: 89.5300261,
    height: 1.36676049
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/house.10cf8398522ad3051c355764240d823c.svg";